import Tabs from "antd/lib/tabs";
import "antd/lib/tabs/style/css";

export default Tabs;
